<template>
  <v-list nav dense class="ehc-menu">
    <template v-for="(item, index) in items">
      <v-divider v-if="item.type == 'divider'" :key="item.type"></v-divider>
      <v-subheader v-else-if="item.type == 'subheader'" :key="item.type">{{
        item.label
      }}</v-subheader>
      <v-list-group
        v-else-if="item.type == 'group'"
        :key="'group-' + index"
        no-action
        class="ehc-menu-group"
        :group="groupPattern(item)"
      >
        <template v-slot:activator>
          <v-list-item-icon v-if="'iconURL' in item" class="mr-3">
            <v-img :src="item.iconURL" contain max-height="22px"></v-img>
          </v-list-item-icon>
          <v-list-item-icon v-else-if="'icon' in item" class="mr-3">
            <v-icon color="#536d91">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.label }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(child, childIndex) in item.children"
          :key="'group-child-' + index + '-' + childIndex"
          @click="linkClick(child)"
          class="ehc-menu-group__child"
          :class="{ 'v-list-item--active primary--text': isActiveRoute(child) }"
        >
          <v-list-item-icon v-if="'icon' in child" class="mr-3">
            <v-icon color="#536d91">{{ child.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-icon v-else-if="'iconURL' in child" class="mr-3">
            <v-img :src="child.iconURL" contain max-height="22px"></v-img>
          </v-list-item-icon>
          <v-list-item-title>{{ itemTitle(child) }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item
        v-else-if="item.type == 'link'"
        @click="linkClick(item)"
        :key="index"
      >
        <v-list-item-icon v-if="'iconURL' in item" class="mr-3">
          <v-img :src="item.iconURL" contain max-height="22px"></v-img>
        </v-list-item-icon>
        <v-list-item-icon v-else-if="'icon' in item" class="mr-3">
          <v-icon color="#536d91">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-title>
          {{ itemTitle(item) }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-else-if="item.type == 'toggle'"
        :key="index"
        @click="linkClick(decideToggle(item))"
      >
        <v-list-item-icon v-if="'iconURL' in decideToggle(item)" class="mr-3">
          <v-img
            :src="decideToggle(item).iconURL"
            contain
            max-height="22px"
          ></v-img>
        </v-list-item-icon>
        <v-list-item-icon v-else-if="'icon' in decideToggle(item)" class="mr-3">
          <v-icon color="#536d91">{{ decideToggle(item).icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ decideToggle(item).label }}
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    items: { type: Array },
    context: { default: true },
  },
  methods: {
    itemTitle(item) {
      if (typeof item.contextLabel === "function") {
        return item.contextLabel(this.context) || item.label;
      }
      return item.label;
    },
    isActiveRoute(item) {
      return "route" in item && this.$route.path === item.route;
    },
    groupPattern(item) {
      const parts = [];
      for (const child of item.children || []) {
        if (typeof child.route !== "string" || !child.route) {
          continue;
        }
        const escaped = child.route.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        parts.push(`^${escaped}$`);
        if (/^\/organization\/[^/]+$/.test(child.route)) {
          parts.push("^/organization/[^/]+$");
        }
      }
      if (!parts.length) {
        return undefined;
      }
      return parts.join("|");
    },
    decideToggle(item) {
      if (this.context[item.key]) {
        return item.onTrue;
      } else {
        return item.onFalse;
      }
    },
    linkClick(item) {
      //   console.log("linkClick", item);
      if ("route" in item) {
        // console.log("Navigating to route:", item.route, this.$route.path);
        if (this.$route.path !== item.route) {
          //   console.log("Pushing route:", item.route);
          this.$router.push(item.route);
        }
      } else if ("emitClick" in item) {
        // console.log("emitting", item.emitClick, this.context)
        this.$emit(item.emitClick, this.context);
      }
    },
  },
};
</script>

<style>
.ehc-menu .v-list-item:hover {
  background-color: #edd4f0 !important;
}

.v-application--is-ltr
  .ehc-nav-drawer
  .ehc-menu.v-list--dense.v-list--nav
  .ehc-menu-group.v-list-group--no-action
  > .v-list-group__items
  > .v-list-item.ehc-menu-group__child {
  padding-left: 8px;
  padding-right: 4px;
}

.ehc-nav-drawer .ehc-menu-group .v-list-group__header {
  padding-left: 8px;
  padding-right: 4px;
}

.ehc-nav-drawer .ehc-menu-group .v-list-group__header__append-icon {
  min-width: 20px;
}

.ehc-nav-drawer .ehc-menu-group .v-list-item__icon {
  margin-right: 8px;
}

.ehc-nav-drawer .ehc-menu-group .v-list-item__title {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.15;
}
</style>
